var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("zk-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.listLoading,
            expression: "listLoading"
          }
        ],
        ref: "table",
        attrs: {
          "sum-text": "sum",
          "index-text": "#",
          data: _vm.list,
          columns: _vm.columns,
          stripe: _vm.props.stripe,
          border: _vm.props.border,
          "show-header": _vm.props.showHeader,
          "show-summary": _vm.props.showSummary,
          "show-row-hover": _vm.props.showRowHover,
          "show-index": _vm.props.showIndex,
          "tree-type": _vm.props.treeType,
          "is-fold": _vm.props.isFold,
          "expand-type": _vm.props.expandType,
          "selection-type": _vm.props.selectionType
        },
        scopedSlots: _vm._u([
          {
            key: "level",
            fn: function(scope) {
              return [
                _c(
                  "el-tag",
                  { attrs: { type: "primary", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(scope.row.level) + "级")]
                )
              ]
            }
          },
          {
            key: "notify",
            fn: function(scope) {
              return [_vm._v(_vm._s(scope.row.notify))]
            }
          },
          {
            key: "deleted",
            fn: function(scope) {
              return [
                scope.row.deleted === false
                  ? _c(
                      "el-tag",
                      {
                        attrs: {
                          type: "primary",
                          effect: "plain",
                          size: "mini"
                        }
                      },
                      [_vm._v("启用")]
                    )
                  : _c(
                      "el-tag",
                      {
                        attrs: {
                          type: "warning",
                          effect: "plain",
                          size: "mini"
                        }
                      },
                      [_vm._v("停用")]
                    )
              ]
            }
          },
          {
            key: "isMail",
            fn: function(scope) {
              return [
                scope.row.isMail == "触发"
                  ? _c(
                      "el-tag",
                      {
                        attrs: {
                          type: "warning",
                          effect: "plain",
                          size: "mini"
                        }
                      },
                      [_vm._v("触发")]
                    )
                  : _c(
                      "el-tag",
                      {
                        attrs: { type: "info", effect: "plain", size: "mini" }
                      },
                      [_vm._v("不触发")]
                    )
              ]
            }
          },
          {
            key: "empower",
            fn: function(scope) {
              return [
                scope.row._level < 4
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/workOrderConsult/create"],
                            expression:
                              "['POST /admin/workOrderConsult/create']"
                          }
                        ],
                        attrs: {
                          type: "text",
                          icon: "el-icon-plus",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCreate(scope.row)
                          }
                        }
                      },
                      [_vm._v("子级")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["POST /admin/workOrderConsult/update"],
                        expression: "['POST /admin/workOrderConsult/update']"
                      }
                    ],
                    attrs: { type: "text", icon: "el-icon-edit", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.handleUpdate(scope.row)
                      }
                    }
                  },
                  [_vm._v("编辑")]
                ),
                _vm._v(" "),
                scope.row.deleted === false
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/workOrderConsult/delete"],
                            expression:
                              "['POST /admin/workOrderConsult/delete']"
                          }
                        ],
                        staticStyle: { color: "red" },
                        attrs: {
                          type: "text",
                          icon: "el-icon-close",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("停用")]
                    )
                  : _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/workOrderConsult/delete"],
                            expression:
                              "['POST /admin/workOrderConsult/delete']"
                          }
                        ],
                        staticStyle: { color: "green" },
                        attrs: {
                          type: "text",
                          size: "mini",
                          icon: "el-icon-check"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleEnable(scope.row)
                          }
                        }
                      },
                      [_vm._v("启用")]
                    )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "typeForm",
              staticStyle: { "margin-left": "50px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.typeForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.typeForm.level == 1,
                      expression: "typeForm.level == 1"
                    }
                  ],
                  attrs: { label: "咨询类型", prop: "type" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.typeForm.id > 0 },
                      model: {
                        value: _vm.typeForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.typeForm, "type", $$v)
                        },
                        expression: "typeForm.type"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("咨询")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("投诉")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "咨询名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "工单咨询类型的名称" },
                    model: {
                      value: _vm.typeForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.typeForm, "name", $$v)
                      },
                      expression: "typeForm.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否触发邮件", prop: "isMail" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.typeForm.isMail,
                        callback: function($$v) {
                          _vm.$set(_vm.typeForm, "isMail", $$v)
                        },
                        expression: "typeForm.isMail"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不触发")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("触发")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { color: "red", "font-size": "12px" } },
                    [
                      _vm._v(
                        "新增投诉时、是否发送邮件提醒到相关工作人员(必须是最后一级)"
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "提醒内容", prop: "notify" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      clearable: "",
                      placeholder: "请输入选中此项时 提醒到操作人员的内容"
                    },
                    model: {
                      value: _vm.typeForm.notify,
                      callback: function($$v) {
                        _vm.$set(_vm.typeForm, "notify", $$v)
                      },
                      expression: "typeForm.notify"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "咨询描述", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入咨询项的描述" },
                    model: {
                      value: _vm.typeForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.typeForm, "remark", $$v)
                      },
                      expression: "typeForm.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createConsultType }
                    },
                    [_vm._v("确定")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateConsultType }
                    },
                    [_vm._v("确定")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }